import HeaderBar from '../HeaderObject.js';
import FooterBar from '../FooterObject.js';

export default function NoPage(){
    return(
        <div>
            <HeaderBar />

            <div className='404' style={{position: 'absolute', top: '50%', left: '50%', textAlign: 'center', transform: 'translate(-50%, -50%)'}}>
                <h1>ERROR 404</h1>
                <p>PAGE NOT FOUND :(</p>
            </div>
 
        </div>
    );
}